export default "<mat-progress-spinner style=\"margin: auto; margin-top: 50px;\" mode=\"indeterminate\">\n</mat-progress-spinner>\n";